import {
  getDiscussionComments,
  reactDiscussion,
  setRoomEditData,
} from '@/actions/room';
import {
  calculateTopThreeEmojisUsed,
  calculateTotalCountLikes,
} from '@/helpers/dataHelper';
import formDataHelper from '@/helpers/formDataHelper';
import { emojis, getReactColor } from '@/helpers/index';
import { Tooltip } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

const LikeAndCommentSection = ({
  each,
  state,
  setDiscussionId,
  roomSlug,
  setState,
  setIsDiscussionReaction,
  setReactionPostData,
  setReactionPostId,
  setEmojiCountModal,
}) => {
  const dispatch = useDispatch();

  const [displayIcon, setDisplayIcon] = useState(true);

  const handleCommentClick = (id) => {
    setDiscussionId(id);
    let linkOpenState = true;
    if (state.open.hasOwnProperty(id)) {
      linkOpenState = !state.open[id];
    }
    setState({
      open: { ...state.open, [id]: linkOpenState },
    });

    if (!state.open[id]) {
      dispatch(
        setRoomEditData({
          name: 'discussionComments',
          key: 'discussionId',
          value: id,
        })
      );
      dispatch(
        getDiscussionComments({
          data: {
            ...setDiscussionId[id]?.query,
            doubt: id,
            room: roomSlug,
            page: 1,
          },
        })
      );
    }
  };

  const onDiscussionLikeClick = (id, reaction) => {
    const values = {
      doubt: id,
      reaction,
    };

    const value = formDataHelper(values, {});

    dispatch(reactDiscussion({ data: value }));
  };

  let timeoutId: any = '';

  const showPopup = (id) => {
    clearTimeout(timeoutId); // Clear any existing timeout
    const element = document.querySelector(
      `.discussion--like__react_${id}`
    ) as HTMLElement;
    if (element) {
      element.style.display = 'flex';
    }
  };

  const hidePopup = (id) => {
    const element = document.querySelector(
      `.discussion--like__react_${id}`
    ) as HTMLElement;

    // Set a timeout to hide the popup after 2 seconds (adjust as needed)
    timeoutId = setTimeout(function () {
      if (element) {
        element.style.display = 'none';
      }
    }, 1000);
  };

  return (
    <>
      {(each?.no_of_likes > 0 || each?.no_comment > 0 || each?.reactions) && (
        <div className={'mb-2 d-flex px-3 align-items-center '}>
          {each?.no_of_likes > 0 && (
            <div className="d-flex align-items-center mr-auto ml-2 like-count cursor-pointer">
              <span
                style={{ fontSize: '19px' }}
                className={`
                                cursor-pointer d-block`}
              >
                {each?.reactions?.length > 0
                  ? calculateTopThreeEmojisUsed(each?.reactions)?.map((el) =>
                      emojis?.map((em) => {
                        if (el?.reaction === em?.title) return em?.value;
                      })
                    )
                  : emojis[0].value}
              </span>
              <span
                className="ml-1 like--count"
                onClick={() => {
                  setIsDiscussionReaction(true);
                  setReactionPostData(each?.reactions);
                  setReactionPostId(each?.id);
                  setEmojiCountModal(true);
                  dispatch(
                    setRoomEditData({
                      name: 'discussionReactionList',
                      key: 'postId',
                      value: each?.id,
                    })
                  );
                }}
              >
                {each?.reactions?.length > 0
                  ? calculateTotalCountLikes(each?.reactions)
                  : each?.no_of_likes}
              </span>
            </div>
          )}
          {each?.no_comment > 0 && (
            <span
              className="ml-auto float-right ml-2 like-count cursor-pointer comment--count"
              onClick={() => {
                handleCommentClick(each.id);
              }}
            >
              {each?.no_comment} {each?.no_comment === 1 ? 'Comment' : 'Comments'}
            </span>
          )}
        </div>
      )}
      <div
        className="action-wrapper-no-image d-flex flex-wrap justify-content-center mx-3 py-2 text-center align-items-center"
        style={{
          borderBottom: `${
            state.open[each?.id] ? '01px solid rgb(216 216 216)' : ''
          }`,
        }}
      >
        <div
          className="col hover-bg py-1 cursor-pointer"
          onClick={() =>
            onDiscussionLikeClick(each.id, each?.user_reaction || 'LIKE')
          }
        >
          <span
            className={`position-relative discussion--like`}
            onMouseOver={() => {
              showPopup(each?.id);
              setDisplayIcon(true);
            }}
            onMouseOut={() => hidePopup(each?.id)}
          >
            <a className={`like-button mr-2`}>
              {each?.like || each?.user_reaction ? (
                each?.user_reaction ? (
                  emojis?.map((el, i) => {
                    if (el?.title === each?.user_reaction)
                      return (
                        <span style={{ fontSize: '17px' }} key={i}>
                          {el?.value}
                        </span>
                      );
                  })
                ) : (
                  <span style={{ fontSize: '19px' }}>{emojis[0]?.value}</span>
                )
              ) : (
                <img
                  src={`${'/images/grey_like.svg'}`}
                  style={{ width: '19px', height: '19px' }}
                  alt="Like"
                />
              )}
            </a>
            <span
              className={`${
                each?.like || each?.user_reaction
                  ? getReactColor(each?.user_reaction)
                  : ''
              } cursor-pointer`}
            >
              {each?.user_reaction
                ? emojis?.map((el) => {
                    if (each?.user_reaction === el?.title) return el?.slug;
                  })
                : 'Like'}
            </span>
            <div
              className={`position-absolute bg-primary px-2 ${
                !displayIcon && 'd-none'
              } discussion--like__react discussion--like__react_${
                each?.id
              } align-items-center m-auto`}
            >
              {emojis?.map((el, i) => (
                <Tooltip title={el?.slug} key={i}>
                  <span
                    style={{ fontSize: '28px' }}
                    className={`${
                      emojis?.length === i + 1 ? '' : 'mr-2 '
                    } cursor-pointer like--react__icons d-block`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setDisplayIcon(false);
                      onDiscussionLikeClick(each.id, el.title);
                    }}
                  >
                    {el?.value}
                  </span>
                </Tooltip>
              ))}
            </div>
          </span>
        </div>
        <div
          className="col hover-bg py-1 cursor-pointer"
          onClick={() => {
            handleCommentClick(each.id);
          }}
        >
          <span className="d-flex justify-content-center ">
            {/* <a className="position-relative d-flex justify-content-center align-items-center like-button ml-3 shadow"> */}
            <a className="like-button mr-2">
              <img
                src="/images/grey_comment.svg"
                style={{ width: '19px', height: '19px' }}
                alt="Comment"
              />{' '}
            </a>
            <span className="cursor-pointer">Comment</span>
          </span>
        </div>
      </div>
    </>
  );
};

export default LikeAndCommentSection;
